<template>
  <div>
    <v-card class="mr-13">
      <v-toolbar color="primary" dark shaped>
        <v-toolbar-title>Lista de Roles</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="mr-16">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              shaped
              single-line
              hide-details
          ></v-text-field>
        </div>
        <v-btn
            color="secondary"
            absolute
            top
            right
            fab
            @click="toogleForm"
            :disabled="showForm"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
          :headers="header"
          :items="groups"
          :search="search"
          :loading="loading"
          loading-text="Cargando... Espere porfavor"
          @change="loadData"
          no-data-text="No existen roles registrados en el sistema."
          :item-key="groups.id"

      >
        <template v-slot:body="props" >
          <tbody name="slide" is="transition-group" mode="out-in" appear>
          <template >
            <tr v-for="(item, index) in props.items" :key="item.id">
              <td>{{index+1}}</td>
              <td>{{item.name}}</td>
              <td> <v-chip color="secondary" small v-for="(perm) in item.permissions.edges" :key="perm.node.id">{{perm.node.name}}</v-chip></td>
              <td>
                <TableAction :item="item" @update="toogleForm" @delaction="deleteItem"/>
              </td>
            </tr>
          </template>
          </tbody>
        </template>

      </v-data-table>
    </v-card>
    <template>
      <group-form v-if="showForm" :title="title" :show-form="showForm"
                    :group="editItem" @close="toogleForm" />
    </template>
    <template>
      <v-dialog persistent max-width="200" transition="dialog-top-transition" v-if="menuLocked" v-model="menuLocked">
        <v-card>
          <v-card-title>Eliminar</v-card-title>
          <v-card-text>Seguro que desea eliminar el rol {{itemToDelete.name}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="terciary"
                text
                @click="deleteItemCancel"
                icon
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                text
                @click="deleteItemConfirm"
                icon
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GroupForm from "../../components/GroupForm";
import TableAction from "../../components/TableAction";

export default {
  name: "Groups",
  // eslint-disable-next-line vue/no-unused-components
  components: {GroupForm, TableAction},
  data:()=>({
    loading: false,
    showForm: false,
    search: '',
    perms:null,
    title:'',
    defaultEditItem: null,
    editItem: null,
    itemToDelete: null,
    menuLocked: false,
    deleteConfirmId: '',
    header: [
      { text: 'No', value: 'num', sortable: false },
      { text: 'Nombre', value: 'name' },
      { text: 'Permisos', value: 'permissions' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
  }),

  computed: {
    ...mapGetters(['groups', 'perms']),
  },
  mounted() {
    if(this.groups.length<=0){
      this.loadData()
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      await this.$store.dispatch("allGroups");
      await this.$store.dispatch("allPerms");
      this.loading = false;
    },

  toogleForm(item){
    this.groups.indexOf(item)=== -1 ? (this.editItem= {}, this.title='Nuevo Rol') :
        (this.editItem = {...item}, this.title='Actualizar Rol');
    this.showForm = ! this.showForm;
  },

  deleteItem(item) {
    this.itemToDelete = item
    this.menuLocked = true
  },

  async deleteItemConfirm() {
    if (this.itemToDelete !== null) {
      await this.$store.dispatch("deleteGroup", this.itemToDelete);
      this.menuLocked = false;
      this.itemToDelete = null;

    }
  },

  deleteItemCancel() {
    this.menuLocked = false
    this.itemToDelete = null
  },

 },

}
</script>

<style scoped>

</style>
